import React, { PropTypes } from 'react';

const ImageDeleteConfirmation = React.createClass({
    propTypes: {
        clones: PropTypes.array,
        onConfirmDeletion: PropTypes.func.isRequired,
        onCancelDeletion: PropTypes.func.isRequired
    },
    render: function () {
        const { clones, onConfirmDeletion, onCancelDeletion } = this.props;
        const hasClones = clones && clones.length > 0;

        return <div>

            {hasClones && <div>
                <h2>Cannot delete image</h2>
                <p className="imageMessage">You must first delete all <strong>{clones.length}</strong> clone(s) to delete this image.</p>
                <button onClick={onCancelDeletion} className="button--ghost small">Okay</button>
            </div>}

            {!hasClones && <div>
                <p className="imageMessage">Are you sure you want to delete this image?</p>
                <button onClick={onConfirmDeletion} className="button--ghost small red">Yes, Delete</button>
                <button onClick={onCancelDeletion} className="button--flat-secondary small">No, Cancel</button>
            </div>}

        </div>;
    }
});

export default ImageDeleteConfirmation;



// WEBPACK FOOTER //
// ./src/components/dashboard/ImageDeleteConfirmation.jsx